import { Component } from '@verndale/core';
import { isPhoneOnly, isTabletPortraitOnly, isDesktopUp } from '../utils/breakpoints'
import { constEvent } from '../utils/constants';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $panelWrapper: document._$('.primary-nav-panel-wrapper'),
      $panel: document._$('.primary-nav-panel'),
      $sidePanelClose: this.el._$('.header__side-panel-close'),
      $panelTablet: document._$('.primary-nav-panel-tablet'),
      $utilitySidePanelClose: document._$('.header__side-panel')._$('.header__side-panel-close'),
      $utilityNav: document._$('.utility-nav'),
      $navCloseTrigger: document._$('.location-selector-wrapper')._$('.account-utility-nav-subnav__close'),
      $locations: document._$('.location-selector-wrapper')._$$('.account-utility-nav-subnav__item '),
      $location: document._$('.location-selector__value'),
      $selects: this.el._$$('.slim-select')
    };

    this.clicked = false;

    this.labels = {
      mainMenu: this.dom.$el.dataset.labelMainMenu
    }

    this.template = {
      close: `
        <button class="primary-nav-panel__close" aria-label="Close panel">
          <svg class="primary-nav-panel__close-icon"><use xlink:href="#close" /></svg>
        </button>
      `,
      back: `
        <button class="primary-nav-panel__back">
          <svg class="primary-nav-panel__back-icon"><use xlink:href="#arrow-left" /></svg>
          ${this.labels.mainMenu}
        </button>
      `,
      items: children => `
        <input id="location-search" type="search" placeholder="search">
        <ul class="location-selector__items" id="location-list">
          ${children.map(({ label, link, selected }) => `
            <li filter-value="${label}" class="location-selector__item ${selected ? 'location-selector__item--selected' : ''}">
              <a class="location-selector__link" href="${link}">
                ${label}
              </a>
            </li>
          `).join('')}
        </ul>
      `
    }

    this.sidePanelExpandedClass = 'header-side-panel-opened';
    this.primaryNavPanelOpenedClass = 'header-primary-nav-panel-opened';
    this.openedPrimaryNavItemClass = 'primary-nav__item--opened';
    this.openedPrimaryNavChildItemClass = 'primary-nav-children__item--opened';
    this.openedLocationSelectorClass = 'location-selector--opened';
    this.selectedClass = 'account-utility-nav-subnav__item--selected';
    this.selectedClass = 'account-utility-nav-subnav__item--selected';

  }

  addListeners() {
    const {
      $selects
    } = this.dom;

    $selects?._on('change', this.validateSelects.bind(this));
    this.dom.$el._on('click', this.openSubNav.bind(this));
    this.dom.$navCloseTrigger._on('click', this.closeSubNav.bind(this));
    document._on('click', this.handleClickOutside.bind(this), false);
    document._on(constEvent.NEW_ACCOUNT_LINKED, this.updateLocation.bind(this));

    setInterval(() => {
      const input = document.getElementById('location-search');
      if (input){
        input.onkeyup = function() {
          const filter = input.value.toUpperCase();
          const lis = document.querySelectorAll('.location-selector__item');
          for (let i = 0; i < lis.length; i++) {
            const name = lis[i].innerText;
            if (name.toUpperCase().indexOf(filter.toUpperCase()) > -1)
              lis[i].style.display = 'list-item';
            else
              lis[i].style.display = 'none';
          }
        }
      }
    }, 5000);

    const searchEle = document.querySelector('.location-selector-wrapper .ss-content');
    searchEle.onkeydown = checkKey;
    /* eslint eqeqeq: 0 */

    let scrollPos = 0;
    window.onload = function(){
      if ($('.location-selector-wrapper .ss-option-selected').length){
        const selectedEleVal = $('.location-selector-wrapper .ss-option-selected').offset().top - 92;
        scrollPos = selectedEleVal;
      }
    }

    function checkKey(e) {
      const listHeight = $('.simplebar-content').height() - $('.simplebar-content-wrapper').height();
      const listWrapper = $('.simplebar-content-wrapper');
      e = e || window.event;
      if (e.keyCode == '38') {
        // up arrow
        scrollPos = scrollPos - 40;
      } else if (e.keyCode == '40') {
        // down arrow
        scrollPos = scrollPos + 40;
      }
      scrollPos = scrollPos < 0 ? 0:scrollPos;
      scrollPos = scrollPos > listHeight ? listHeight:scrollPos;
      listWrapper.scrollTop(scrollPos);
    }

  }

  validateSelects(e) {
    try {
      this.pristineForm.validate(e.target);
    } catch (error) {
      return;
    }
  } //validateSelects

  addChildMenuListeners() {
    let $container;
    if (isPhoneOnly()) {
      $container = this.dom.$panel;
      $container._$('.primary-nav-panel__back')._on('click', this.handleMainMenuClick.bind(this))
      $container._$('.primary-nav-panel__close')._on('click', this.closeSubNav.bind(this));
    } else if (isTabletPortraitOnly()) {
      $container = this.dom.$panelTablet;
    }
  }

  opensidePanel() {
    this.dom.$el.classList.add('test');
    document.body.classList.add(this.primaryNavPanelOpenedClass);
    this.dom.$el.classList.add(this.openedLocationSelectorClass);
    if (isTabletPortraitOnly()) {
      document.body.classList.add(this.sidePanelExpandedClass);
    }
    if (isDesktopUp()) {
      this.dom.$el.classList.add(this.openedLocationSelectorClass);
    }
  }

  closesidePanel() {
    if (!isDesktopUp()) {
      document.body.classList.remove(this.primaryNavPanelOpenedClass);
    }
    document.body.classList.remove(this.sidePanelExpandedClass);
  }

  openSubNav(e) {
    const isDesktop = isDesktopUp();
    if (isDesktop && this.el.classList.contains(this.openedLocationSelectorClass)) {
      this.closeSubNav();
    } else {
      this.closeSubNav();
      if (!isDesktop) this.currentNav = JSON.parse(this.dom.$el.dataset.countries);
      this.opensidePanel();
      if (isDesktop) this.removeChildMenu();
      if (!isDesktop) this.renderChildMenu();
    }
  }

  closeSubNav() {
    if (this.clicked) return;

    this.closesidePanel();
    if (isDesktopUp()) {
      this.dom.$el.classList.remove(this.openedLocationSelectorClass);
    }
  }

  buildChildMenu() {
    if (isPhoneOnly()) {
      return `
          ${this.template.close}
          ${this.template.back}
          ${this.template.items(this.currentNav)}
      `;
    }

    if (isTabletPortraitOnly()) {
      return `
        ${this.template.items(this.currentNav)}
      `;
    }
  }

  renderChildMenu() {
    let $container;

    if (isPhoneOnly() || isDesktopUp()) {
      $container = this.dom.$panel;
    } else if (isTabletPortraitOnly()) {
      $container = this.dom.$panelTablet;
    }

    $container.innerHTML = this.buildChildMenu();
    this.addChildMenuListeners();
  }

  removeChildMenu() {
    this.dom.$panel.innerHTML = '';
    this.dom.$panelTablet.innerHTML = '';
  }

  handleMainMenuClick() {
    this.closeSubNav();
    if (isPhoneOnly()) {
      document.body.classList.add(this.sidePanelExpandedClass);
    } else if (isTabletPortraitOnly()) {
      document.body.classList.add(this.sidePanelExpandedClass);
      document.body.classList.add(this.primaryNavPanelOpenedClass);
    }
  }

  handleClickOutside(e) {
    console.log(e.target);
    if (!isDesktopUp()) return;
    if (e.target.closest('.location-selector')) return;
    if (e.target.getAttribute('id') === 'location-search') return;
    if (e.target.closest(`.${this.openedLocationSelectorClass}`)) return;
    this.closeSubNav();
  }

  updateLocation(e) {
    const location = e.detail.location;
    this.dom.$location.textContent = location;
    this.dom.$locations.forEach(loc => {
      const isSame = loc.textContent.trim().toUpperCase() === location.trim().toUpperCase();
      if (isSame) {
        loc.classList.add(this.selectedClass);
      } else {
        loc.classList.remove(this.selectedClass);
      }
    });
  }

}

export default Module;
